import $ from 'jquery';
import SP from 'signature_pad';

(function ($, SignaturePad) {
  $(document).ready(function () {

    if ($('#add_document').length < 1) {
      return;
    }

    let askBeforeUnload = true;

    if (typeof window.addEventListener === 'undefined') {
      window.addEventListener = function (e, callback) {
        return window.attachEvent('on' + e, callback);
      }
    }

    window.addEventListener('beforeunload', function (e) {
      if (askBeforeUnload) {
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = 'Czy na pewno chcesz opuścić formularz?';
      } else {
        delete e['returnValue'];
      }
    });

    $('#add_document').submit(function () {
      askBeforeUnload = false;
      return true;
    });

    const initPads = () => {
      initPad('#signature-pad-employee', '[employee_signature]');
      initPad('#signature-pad-user', '[vehicle_user_signature]');
      initPad('#signature-pad-gdpr', '[gdpr_signature]');
    };
    window.onresize = initPads;
    initPads();

    if ($('[name$="[employee_signature][content]"]').val()) {
      $('[name$="[employee_signature][content]"]').after($('<div style="font-size:8pt;margin-bottom: 1em;">').html($('[name$="[employee_signature][content]"]').val()));
    }
    if ($('[name$="[vehicle_user_signature][content]"]').val()) {
      $('[name$="[vehicle_user_signature][content]"]').after($('<div style="font-size:8pt;margin-bottom: 1em;">').html($('[name$="[vehicle_user_signature][content]"]').val()));
    }
    if ($('[name$="[gdpr_signature][content]"]').val()) {
      $('[name$="[gdpr_signature][content]"]').after($('<div style="font-size:8pt;margin-bottom: 1em;">').html($('[name$="[gdpr_signature][content]"]').val()));
    }

    // CKFinder.widget('ckfinder1', {
    //   displayFoldersPanel: true,
    //   defaultViewType: 'list'
    // });

    $('[name="doc[no_fleet_manager]"], [name="doc[no_vehicle_user]"]').click(function () {
      if ($(this).is(':checked')) {
        $(this).closest('.accordion-content').find('label:gt(0)').hide();
        $('.js_hideWhenNoUser').hide();
      } else {
        $(this).closest('.accordion-content').find('label:gt(0)').show();
        $('.js_hideWhenNoUser').show();
      }
    }).trigger('click');
    $('.js_tyreSize').on('keyup', function (event) {
      let val = $(this).val();
      let key = event.which || event.keyCode || event.charCode;
      if (key === 8) {
        return;
      }
      if (val.match(/^[0-9]{3}$/)) {
        $(this).val(val + '/');
      } else if (val.match(/^\d{3}\/\d{2}$/)) {
        $(this).val(val + 'R');
      }
    });
    $('.js_addAxle').click(function (e) {
      e.preventDefault();
      let currentCount = Date.now(); //$(this).closest('.tyres-fieldsets').find('fieldset > fieldset').length;
      let template = $(this).closest('.tyres-fieldsets').find('fieldset > span').data('template');
      template = template.replace(/__index__/g, currentCount);

      let lastInsertedValues = {};
      $(this).closest('.tyres-fieldsets').children('fieldset').children('fieldset').last().find('input, select').each(function () {
        if ($(this).attr('name')) {
          let fieldName = $(this).attr('name').match(/[a-zA-Z0-9-]+(?=\]$)/);
          lastInsertedValues[fieldName] = $(this).val();
        }
      });
      $(this).closest('.tyres-fieldsets').children('fieldset').append(template);

      $(this).closest('.tyres-fieldsets').children('fieldset').children('fieldset').last().find('.js_data_make').val(
        lastInsertedValues['make']
      );
      $(this).closest('.tyres-fieldsets').children('fieldset').children('fieldset').last().find('.js_data_model').val(
        lastInsertedValues['model']
      );
      $(this).closest('.tyres-fieldsets').children('fieldset').children('fieldset').last().find('.js_data_type').val(
        lastInsertedValues['type']
      );
      $(this).closest('.tyres-fieldsets').children('fieldset').children('fieldset').last().find('.js_tyreSize').val(
        lastInsertedValues['size']
      );

      numerizeFieldsets();
      return false;
    });
    numerizeFieldsets();

    $('[name$="[vehicle_user][last_name]"]').change(function () {
      $('[name$="[vehicle_user_signature][name]"]').val(
        $('[name$="[vehicle_user][first_name]"]').val()
        + ' '
        + $('[name$="[vehicle_user][last_name]"]').val()
      );
      $('[name="[gdpr_signature][name]"]').val(
        $('[name$="[vehicle_user][first_name]"]').val()
        + ' '
        + $('[name$="[vehicle_user][last_name]"]').val()
      );
    });

    if ($('#vehicle-app').length > 0) {
      require('./Vehicle/main');
    }
    if ($('#interior-app').length > 0) {
      require('./Interior/main');
    }
    if ($('#checklist-app').length > 0) {
      require('./Checklist/main');
    }
    if ($('#parts-app').length > 0) {
      require('./Parts/main');
    }
    if ($('#tyres').length > 0) {
      require('./Tyres/main');
    }
  });

  const numerizeFieldsets = () => {
    let cnt = 1;
    $('.tyres-fieldsets > fieldset > fieldset').each(function () {
      const id = $('.js_data_model', this).attr('name').match(/\[(\d+)\]/)[1];
      $(this).attr('data-id', id);
      if ($(this).find('legend').length === 0) {
        $(this).prepend('<legend>');
      }
      const legend = $(this).find('legend');
      legend.html('');
      legend.text(window.TYRES_FIELDSET_LABEL.replace('_ID_', cnt));
      cnt++;
      if (id === '0') {
        return;
      }
      legend.append(
        $('<a class="" style="margin-left: 1em">')
          .text('(Usuń)')
          .click(function () {
            $('fieldset[data-id=' + id + ']').remove();
          })
      );
    });
  }

  const initPad = (wrapper, target) => {
    if ($(wrapper).length < 1) {
      return;
    }
    const canvas = $('canvas', wrapper)[0];
    $('canvas', wrapper).css('background-color', '#efefef');
    const signaturePad = new SignaturePad(canvas, {
      backgroundColor: "rgb(0, 0, 0, 0)",
      throttle: 0,
      onEnd: function () {
        $('[name$="' + target + '[signature][data]"').val(JSON.stringify({
          data: signaturePad.toData(),
          blob: signaturePad.toDataURL()
        }));
        $('[name$="' + target + '[signed_on]"').val(Math.floor(Date.now() / 1000));
      }
    });
    canvas.width = 300;
    canvas.height = 300;
    // let ratio = Math.max(window.devicePixelRatio || 1, 1);
    // canvas.width = canvas.offsetWidth * ratio;
    // canvas.height = canvas.offsetHeight * ratio;
    // canvas.getContext("2d").scale(ratio, ratio);
    signaturePad.clear();
    $('.clear-pad', wrapper).click(function () {
      signaturePad.clear();
    });
    if ($('[name$="' + target + '[signature][data]"').val()) {
      signaturePad.fromData(JSON.parse($('[name$="' + target + '[signature][data]"').val())['data']);
    }
  };

})($, SP);
